import { push } from "react-router-redux";
import api from "APP_ROOT/api";
import _, { get } from "lodash";
import { SUCCESS } from "LIB/submission/constants";
import { List } from "immutable";
import { ACTIVE, CREDIT_HOLD, NO_BIZ } from "MODULES/companies/constants";
import { toastr } from "react-redux-toastr";
import {
  DO_NOT_SHIP,
  DO_NOT_SHIP_REASONS
} from "MODULES/PurchaseOrders/constants";
import { ID } from "APP_ROOT/constants";
import { modifyFormDataForContact } from "MODULES/parts/components/Detail/PurchaseOrders/Create/Create";
import * as actionTypes from "./actionTypes";
import {
  expireReceivedCores,
  purchaseOrderLineItems as purchaseOrderLineItemsPagination
} from "./pagination";

function refreshPurchaseOrderAndLineItems(dispatch, purchaseOrderID) {
  return api.purchaseOrders.show(purchaseOrderID).then(resp => {
    dispatch({ type: actionTypes.SET, purchaseOrder: resp.data });
    dispatch(purchaseOrderLineItemsPagination.pageActions.expire());
  });
}

const getPurchaseOrderDetailId = getState =>
  getState().purchaseOrderDetail.getIn(["purchaseOrder", "id"]);

export function create(data) {
  return (dispatch, getState) => {
    const partFromState = getState().partDetail.get("part");

    if (data.contact_id === "Add") {
      data.contact_id = null;
    }

    return api.purchaseOrders.create(data).then(resp => {
      const id = resp.data.id;
      const part = data.persistPart ? partFromState.toJS() : {};
      dispatch(
        push({
          pathname: `/purchase-orders/${id}`,
          state: { part, open: true, id }
        })
      );
      return SUCCESS;
    });
  };
}

export function cancel(reason) {
  return (dispatch, getState) => {
    const purchaseOrderID = getState().purchaseOrderDetail.getIn([
      "purchaseOrder",
      "id"
    ]);

    return api.purchaseOrders
      .cancel(purchaseOrderID, reason)
      .then(() => {
        refreshPurchaseOrderAndLineItems(dispatch, purchaseOrderID);
        return Promise.resolve();
      })
      .catch(error => {
        toastr.error("Error", _.get(error, "errors.base[0]"), error.message);
      });
  };
}

export function approve() {
  return (dispatch, getState) => {
    const purchaseOrderID = getPurchaseOrderDetailId(getState);
    return api.purchaseOrders
      .update(purchaseOrderID, { approved: true })
      .then(resp => {
        dispatch({
          type: actionTypes.SET,
          purchaseOrder: resp.data
        });
        return SUCCESS;
      });
  };
}

export function setTraceHold(val) {
  return (dispatch, getState) => {
    const purchaseOrderID = getPurchaseOrderDetailId(getState);

    return api.purchaseOrders.setTraceHold(purchaseOrderID, val).then(resp => {
      dispatch({
        type: actionTypes.SET,
        purchaseOrder: resp.data
      });

      toastr.success(
        "Success",
        val
          ? "Approved Trace Hold"
          : "Rejected Trace Hold, Notification has been sent to Buyer."
      );

      return SUCCESS;
    });
  };
}

export function show(id) {
  return dispatch =>
    api.purchaseOrders.show(id).then(resp => {
      dispatch({
        type: actionTypes.SET,
        purchaseOrder: resp.data
      });
    });
}

export function update(data) {
  return (dispatch, getState) => {
    const purchaseOrderID = getState().purchaseOrderDetail.getIn([
      "purchaseOrder",
      ID
    ]);

    modifyFormDataForContact(data);

    if (data.shipping_type && data.shipping_type !== DO_NOT_SHIP) {
      DO_NOT_SHIP_REASONS.forEach(field => {
        data[field] = false;
      });
    }

    return api.purchaseOrders.update(purchaseOrderID, data).then(resp => {
      dispatch({
        type: actionTypes.SET,
        purchaseOrder: resp.data
      });
      dispatch(purchaseOrderLineItemsPagination.pageActions.expire());
      return SUCCESS;
    });
  };
}

export function updateQcStatus(data) {
  return (dispatch, getState) => {
    const purchaseOrderID = getState().purchaseOrderDetail.getIn([
      "purchaseOrder",
      "id"
    ]);
    return api.purchaseOrders
      .updateQcStatus(purchaseOrderID, data)
      .then(resp => {
        dispatch({
          type: actionTypes.SET,
          purchaseOrder: resp.data
        });
        dispatch(purchaseOrderLineItemsPagination.pageActions.expire());
        return SUCCESS;
      });
  };
}

export function bulkUpdateLineItems(data) {
  return (dispatch, getState) => {
    const purchaseOrderID = getState().purchaseOrderDetail.getIn([
      "purchaseOrder",
      "id"
    ]);
    return api.purchaseOrders.lineItems
      .bulkUpdate(purchaseOrderID, data)
      .then(resp => {
        dispatch({
          type: actionTypes.SET,
          purchaseOrder: resp.data
        });
        dispatch(expireReceivedCores());
        dispatch(purchaseOrderLineItemsPagination.pageActions.expire());
        return SUCCESS;
      });
  };
}

export const searchLineItems = pageInfo => (dispatch, getState) => {
  const results = getState()
    .purchaseOrderDetail.getIn(["purchaseOrder", "line_items"], List())
    .toJS();
  const { limit, page } = pageInfo.query;
  const data = {
    total_count: results.length,
    results: results.slice(limit * page - limit, page * limit)
  };

  return Promise.resolve({ data });
};

export function addLineItem(values, purchaseOrderId, afterCreate) {
  return (dispatch, getState) => {
    const poId =
      purchaseOrderId ||
      getState().purchaseOrderDetail.getIn(["purchaseOrder", "id"]);

    if (!values.purchase_for_sale) {
      values.reserve_for_seller_id = null;
    }

    if (values.displayCoBuyerFields) {
      values.add_co_buyer = true;
    }

    if (values.displayThirdBuyerFields) {
      values.add_third_buyer = true;
    }

    return api.purchaseOrders.lineItems.create(poId, values).then(() => {
      if (afterCreate) {
        afterCreate();
      } else {
        refreshPurchaseOrderAndLineItems(dispatch, poId);
      }
      return SUCCESS;
    });
  };
}

export function updateLineItem(lineItemId, values) {
  return (dispatch, getState) => {
    const purchaseOrderID = getState().purchaseOrderDetail.getIn([
      "purchaseOrder",
      "id"
    ]);

    if (!values.purchase_for_sale && values.reserve_for_seller_id) {
      values.reserve_for_seller_id = null;
    }

    return api.purchaseOrders.lineItems.update(lineItemId, values).then(() => {
      refreshPurchaseOrderAndLineItems(dispatch, purchaseOrderID);
      return SUCCESS;
    });
  };
}

export function searchAlternates(partId) {
  return () =>
    api.parts.alternates
      .search(partId, { page: 1, limit: 10 })
      .then(resp => resp.data.results);
}

export function searchBuyers(filter) {
  return () =>
    api.users
      .search({ active: true, filter, page: 1, limit: 10 })
      .then(resp => Promise.resolve(resp.data.results));
}

export function searchCompanies(filter) {
  return () =>
    api.companies
      .search({
        cached: true,
        filter,
        status: [ACTIVE, NO_BIZ, CREDIT_HOLD].join(","),
        sort: "name",
        reverse: false,
        page: 1,
        limit: 20
      })
      .then(resp => Promise.resolve(resp.data.results));
}

export function searchRepairStations(filter) {
  return () =>
    api.companies
      .search({
        filter,
        repair_station: true,
        page: 1,
        limit: 10
      })
      .then(resp => Promise.resolve(resp.data.results));
}

export function sync() {
  return (dispatch, getState) => {
    const purchaseOrderID = getState().purchaseOrderDetail.getIn([
      "purchaseOrder",
      "id"
    ]);
    return api.purchaseOrders
      .sync(purchaseOrderID)
      .then(() => {
        toastr.success("SUCCESS", "Successfully Synced.");

        return SUCCESS;
      })
      .catch(response => {
        toastr.error("ERROR", get(response, "errors", "Sync Failed"));
      });
  };
}



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/actions.js